import React from "react";

import {
  CopyableSpecValue,
  SpecRow,
} from "components/Environment/shared/SpecTable";

import type { AddedComputeNode } from "./types";

const DgxComputeIdentity: React.FC<{ node: AddedComputeNode }> = ({ node }) => (
  <div className="flex flex-col items-center gap-3 border-b border-zinc-800 bg-zinc-950/40 px-4 py-5 text-center">
    {node.productImageSrc ? (
      <img
        src={node.productImageSrc}
        alt={node.productName}
        className={
          node.productName === "DGX Station"
            ? "w-full max-w-32 rounded-sm object-contain"
            : "w-full max-w-56 rounded-sm object-contain"
        }
      />
    ) : null}
    <span className="block w-full whitespace-nowrap text-center text-md font-bold leading-none tracking-tight text-white">
      {node.productName}
    </span>
  </div>
);

export const ComputeResourcesTable: React.FC<{ node: AddedComputeNode }> = ({
  node,
}) => {
  const isDgxProduct = Boolean(node.productName);

  return (
    <section>
      <div className="mb-4 flex h-9 items-center">
        <h2 className="text-base font-semibold text-primary">This device</h2>
      </div>
      <div className="overflow-hidden rounded-sm border border-zinc-800/80">
        {isDgxProduct ? <DgxComputeIdentity node={node} /> : null}
        <table
          className="w-full table-fixed border-collapse"
          aria-label="Added node hardware specifications"
        >
          <tbody className="divide-y divide-zinc-800/80">
            <SpecRow label="GPU" value={node.gpu} />
            <SpecRow label="vCPUs" value={node.cpuCores} />
            <SpecRow label="Memory" value={node.memory} />
            <SpecRow label="Architecture" value={node.architecture} />
          </tbody>
        </table>
      </div>
    </section>
  );
};

export const NetworkDetailsTable: React.FC<{ node: AddedComputeNode }> = ({
  node,
}) => (
  <section className="mt-7 max-[1024px]:mt-0 max-[640px]:mt-0">
    <div className="mb-4 flex h-9 items-center">
      <h2 className="text-base font-semibold text-primary">Network</h2>
    </div>
    <div className="overflow-hidden rounded-sm border border-zinc-800/80">
      <table
        className="w-full table-fixed border-collapse"
        aria-label="Added node network details"
      >
        <tbody className="divide-y divide-zinc-800/80">
          <SpecRow
            label="Private DNS"
            value={
              <CopyableSpecValue value={node.meshDnsName} label="private DNS" />
            }
          />
          <SpecRow
            label="Mesh IP"
            value={<CopyableSpecValue value={node.meshIp} label="mesh IP" />}
          />
        </tbody>
      </table>
    </div>
  </section>
);
